import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import serviceLocationType from '../constants/serviceLocationTypes';
import iconPack from './IconsPack';
import ConfigStore from '../stores/Config';

const styles = {
  businessAddressLabel: {
    marginTop: 'xsmall',
    fontSize: 'small',
    marginLeft: 'xxsmall'
  }
};

const BusinessAddress = ({
  service,
  isOlaBookingServiceLocationExperimentEnabled,
  staticContent,
  as: T = UX2.Element.Text,
  ...props
}) => {
  const { Element, Icon } = UX2.Element;
  const { formatted_business_address: formattedBusinessAddress } = ConfigStore.getState();
  const businessAddress = formattedBusinessAddress?.join(', ');

  const [addressDetails, setAddressDetails] = React.useState({
    businessAddressText: '',
    icon: ''
  });
  const locationType = service.location_type;
  const customLocationText = service?.custom_location_text || '';

  React.useEffect(() => {
    switch (locationType) {
      case serviceLocationType.BUSINESS_LOCATION:
        setAddressDetails({
          businessAddressText: businessAddress,
          icon: 'addressLocation'
        });
        break;
      case serviceLocationType.CUSTOMER_LOCATION:
        setAddressDetails({
          businessAddressText: staticContent.customerLocation,
          icon: 'addressLocation'
        });
        break;
      case serviceLocationType.OHTER_LOCATION:
        setAddressDetails({
          businessAddressText: customLocationText,
          icon: 'addressLocation'
        });
        break;
      case serviceLocationType.ONLINE:
        setAddressDetails({
          businessAddressText: staticContent.onlineLocation,
          icon: 'videoPin'
        });
        break;
      default:
        setAddressDetails({
          businessAddressText: '',
          icon: ''
        });
    }
  }, [locationType, customLocationText, businessAddress]);

  if (!isOlaBookingServiceLocationExperimentEnabled) return null;

  return (
    <T { ...props }>
      <Icon iconPack={ iconPack } icon={ `${addressDetails.icon}` } size='20' />
      <Element style={ styles.businessAddressLabel }>{ addressDetails.businessAddressText }</Element>
    </T>
  );
};

BusinessAddress.propTypes = {
  service: PropTypes.object,
  staticContent: PropTypes.object,
  as: PropTypes.element,
  isOlaBookingServiceLocationExperimentEnabled: PropTypes.bool
};

export default BusinessAddress;
